import {
  ApplicationHeader as BeyondApplicationHeader,
  LogoProps,
  styled,
} from '@zeiss/beyond-online-react';
import { useBreakpoint } from '@zeiss/lib-helpers';

const HeaderContent = styled.div`
  display: flex;
  gap: var(--spacing-responsive-s);
  align-items: center;
  justify-content: center;
`;

interface HeaderProps {
  accountMenu?: React.ReactNode;
  applicationTitle: string;
  burgerIcon?: React.ReactNode;
  onLogoClick?: LogoProps['onClick'];
}

export const Header = ({
  accountMenu,
  applicationTitle,
  burgerIcon,
  onLogoClick,
}: HeaderProps) => {
  const isMinTablet = useBreakpoint('tablet');

  return (
    <BeyondApplicationHeader
      applicationTitle={applicationTitle}
      logo={{
        onClick: onLogoClick,
      }}
      primaryUtilities={[
        {
          content: (
            <HeaderContent>
              {accountMenu}
              {!isMinTablet ? burgerIcon : null}
            </HeaderContent>
          ),
          visibleOnMobile: true,
        },
      ]}
      shellLayout="with-side-nav"
    />
  );
};
